import _ from 'lodash';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { Select, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { ISubcode } from '../../models/codes.model';

interface IYearSelect {
  semesterType: string;
  setSemesterType: (semesterType: string) => void;
  hasAllOption: boolean
  disabled?: boolean
}

const SemesterTypeSelect = ({ semesterType, setSemesterType, hasAllOption = true, disabled = false }: IYearSelect) => {
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const { t } = useTranslation();

  // commonCodes 로딩 이후 컴포넌트가 생성 된다.
  if (!commonCodes || !(commonCodes.length > 0)) {
    return <Skeleton.Button active={true} size={'default'} shape={'default'} block={false} />;
  }

  // PR0002 = 학기 유형
  const PR0002 = commonCodes.find(
    (item) => item.commonCode === 'PR0002',
  )?.detailCode;

  if (!PR0002) return <Skeleton.Button active={true} size={'default'} shape={'default'} block={false} />;

  const all = { label: t('common.text.all'), value: 'all' };

  return (
    <Select
      value={semesterType}
      onChange={value => setSemesterType(value)}
      disabled={disabled}
    >
      {
        hasAllOption && (
          <Select.Option value={all.value}>
            {all.label}
          </Select.Option>
        )
      }
      {
        PR0002.map((item: ISubcode) => {
          return (
            <Select.Option
              key={item.detailCode}
              value={item.detailCode}
            >
              {item.korName}
            </Select.Option>
          )
        })
      }
    </Select>
  )
}

export default SemesterTypeSelect;